import { render, staticRenderFns } from "./single_stat.vue?vue&type=template&id=0323a23a"
import script from "./single_stat.vue?vue&type=script&lang=js"
export * from "./single_stat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports